// This adds support for direct upload to S3, without going through the Rails server as an intermediary. It
// also provides progress updates for larger files, as well as error handling and completion notifications.
$(document).ready(function () {
  addEventListener("direct-upload:initialize", (event) => {
    const { target, detail } = event;
    const { id, file } = detail;
    target.insertAdjacentHTML(
      "beforebegin",
      `
      <div id="direct-upload-${id}" class="direct-upload direct-upload--pending">
        <div class="direct-upload__progress" style="width: 0%"></div>
        <span class="direct-upload__filename">${file.name}</span>
      </div>
    `,
    );

    // Show progress container
    $(".upload-progress").show();
    $("#upload-button").prop("disabled", true);
  });

  addEventListener("direct-upload:start", (event) => {
    const { id } = event.detail;
    const element = document.getElementById(`direct-upload-${id}`);
    element.classList.remove("direct-upload--pending");
  });

  addEventListener("direct-upload:progress", (event) => {
    const { id, progress } = event.detail;
    const progressElement = document
      .getElementById(`direct-upload-${id}`)
      .querySelector(".direct-upload__progress");
    progressElement.style.width = `${progress}%`;

    // Update main progress bar
    $(".progress-bar").css("width", progress + "%");
    $(".upload-status").text("Uploading... " + Math.round(progress) + "%");
  });

  addEventListener("direct-upload:error", (event) => {
    event.preventDefault();
    const { id, error } = event.detail;
    const element = document.getElementById(`direct-upload-${id}`);
    element.classList.add("direct-upload--error");
    element.setAttribute("title", error);

    // Show error message
    $(".upload-status").text("Upload failed: " + error);
    $("#upload-button").prop("disabled", false);
  });

  addEventListener("direct-upload:end", (event) => {
    const { id } = event.detail;
    const element = document.getElementById(`direct-upload-${id}`);
    element.classList.add("direct-upload--complete");

    // Update status
    $(".upload-status").text("Upload complete!");

    // Re-enable submit button after a short delay
    setTimeout(function () {
      $("#upload-button").prop("disabled", false);
    }, 500);
  });

  // Initialize file input
  const fileInput = document.querySelector(
    'input[type="file"][data-direct-upload-url]',
  );
  if (fileInput) {
    fileInput.addEventListener("change", (event) => {
      const files = event.target.files;
      if (files.length > 0) {
        const file = files[0];
        const maxSize = 50 * 1024 * 1024; // 50MB

        if (file.size > maxSize) {
          alert("File size must be less than 50MB");
          event.target.value = "";
          return;
        }

        // Enable upload button when file is selected
        $("#upload-button").prop("disabled", false);
      }
    });
  }
});

// Style for direct upload progress
document.addEventListener("DOMContentLoaded", function () {
  const style = document.createElement("style");
  style.textContent = `
    .direct-upload {
      display: inline-block;
      position: relative;
      padding: 2px 4px;
      margin: 0 3px 3px 0;
      border: 1px solid rgba(0, 0, 0, 0.3);
      border-radius: 3px;
      font-size: 11px;
      line-height: 13px;
    }

    .direct-upload--pending {
      opacity: 0.6;
    }

    .direct-upload__progress {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      background: rgba(0, 130, 0, 0.2);
    }

    .direct-upload--complete .direct-upload__progress {
      background: rgba(0, 130, 0, 0.4);
    }

    .direct-upload--error {
      border-color: red;
      background: rgba(255, 0, 0, 0.1);
    }

    .direct-upload__filename {
      position: relative;
    }

    .upload-progress {
      margin-top: 10px;
    }
  `;
  document.head.appendChild(style);
});
